export const appInfo = {
  name: "Dezzling gems ventures",
  motto: "LEARN,LAUGH and GROW.",
  vision:
    "We aim at producing lifelong learners and well enlightened global citizens processing the best of intellectual abilities coupled with the right and most pristine moral values",
  address: "Thecodeunit",
  email: "thecodeunit@gmail.com",
  phone: "27282",
};
